<template>
  <div>
    <div class="course-header">
      <div class="course-header-content">
        <div class="media">
          <div class="media-left">
            <img width="48" src="https://python123.io/images/landing/course-iclass-numpy.svg" alt="">
          </div>
          <div class="media-content">
            <div class="heading">Python123 互动课堂</div>
            <div class="course-name">{{ IClassroom.course.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="course-groups">
      <div class="heading">课程目录</div>
      <div v-for="(chapter, index) in chapters">
        <div class="title"
             :class="{'collapsed': chaptersCollapse[index]}"
             @click="$set(chaptersCollapse, index, !chaptersCollapse[index])">
          {{ index + 1 }}. {{ chapter.name }}
          <button class="button is-small collapse-button">
            <v-color-icon name="arrow-down-s"
                          :rotate="chaptersCollapse[index] ? 0 : 180"></v-color-icon>
            <span v-if="chaptersCollapse[index] === '学完'">学完</span>
          </button>
        </div>
        <div>
          <div v-for="group in chapter.groups"
               v-show="!chaptersCollapse[index]">
            <div v-if="group.subtype === 'igroup'"
                 class="group-wrapper">
              <div class="card"
                   :id="'group-' + group._id"
                   :class="{'is-lock': group.lock, 'is-active': IClassroom.group && IClassroom.group._id === group._id}"
                   :key="'group-' + group._id"
                   @click="select(group)">
                <div class="card-content">
                  <div class="index">
                    <span>{{ index + 1 }}</span>
                  </div>
                  <div class="single-line">
                    <p class="heading">互动课堂</p>
                    <p v-if="!group.lock" class="single-line"><b>{{ group.name }}</b></p>
                    <div v-else>？？？</div>
                  </div>
                  <div v-if="group.lock" class="flex-pull-right">
                    <v-color-icon name="lock" size="20"></v-color-icon>
                  </div>
                  <div v-if="group.commits && group.commits.commit_at" class="flex-pull-right">
                    <v-color-icon name="check" size="20"></v-color-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <exit-group-modal
        @exit="exit"></exit-group-modal>
  </div>
</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'
import ExitGroupModal from '@/components/classroom/web/modals/ExitGroupModal'
import { MESSAGE_COURSE_END } from '@/components/classroom/lib/MessageId'

const IDE = window['IDE']

export default {
  components: { ExitGroupModal },
  props: { 'groups': {} },
  data () {
    return {
      IClassroom,
      selectedGroup: null,
      chapters: [],
      chaptersCollapse: []
    }
  },
  watch: {
    groups () {
      this.loadChapter(false)
    }
  },
  methods: {
    select (group) {
      if (!group.lock) {
        this.selectedGroup = group
        if (IClassroom.group.done || (IClassroom.lastCourseMessage && IClassroom.lastCourseMessage.id === MESSAGE_COURSE_END)) {
          this.exit()
        } else {
          IDE.modals.exitGroup.active = true
        }
      } else {
        this.$noty.info('学习上一章节后解锁')
      }
    },
    exit () {
      this.$emit('change', this.selectedGroup)
      IDE.modals.exitGroup.active = false
    },
    loadChapter (setCollapse) {
      const chapters = []
      const collapsed = []
      this.groups.forEach(group => {
        if (group.chapter) {
          chapters.push({
            name: group.chapter,
            collapse: true,
            groups: []
          })
          collapsed.push(true)
        }
        const chapter = chapters[chapters.length - 1]
        chapter.groups.push(group)
        collapsed[collapsed.length - 1] &= !!(group.commits && group.commits.commit_at)
      })
      this.chapters = chapters
      if (setCollapse) {
        this.chaptersCollapse = collapsed.map(c => c ? '学完' : 0)
      }
    }
  },
  mounted () {
    this.loadChapter(true)
  }
}
</script>

<style lang="stylus" scoped>
.course-groups {
  font-size 14px
  height 100%
  overflow-y auto
  overflow-x hidden
  padding 1rem
  padding-bottom 20vh
  background linear-gradient(45deg, #B5C6E1, #F4F5FA, #E6EBF8)
  background $neBg
  position relative
  user-select none
  width 300px
}

.course-header {
  display flex
  flex-direction column
  padding 1rem
  justify-content center
  border-bottom 2px solid $dark
  width 300px
  margin-bottom -2rem
}

.course-header-content {
  padding 1rem 0
  border-bottom 1px solid #dddddd
  margin-bottom 1rem
}

.python123 {
  font-size 12px
}

.course-name {
  font-weight bold
}

.heading {
  font-size 12px
  color #888888
}

.title {
  font-size 12px
  margin 2rem 0 .5rem
  padding .3rem 0
  font-weight bold
  cursor pointer

  &.collapsed {
    border-bottom 1px solid #dddddd
  }

  &:first-child {
    margin-top 0
  }
}

.group-wrapper {
  position relative

  &:after {
    content ''
    position absolute
    left 0
    top 0
    bottom 0
    right 0
    background $neBg
    border-radius 3px
    box-shadow inset 7px 7px 15px rgba(55, 84, 170, 0.15), inset -7px -7px 20px white, 0px 0px 4px rgba(255, 255, 255, 0.2);
  }
}

.collapse-button {
  position: absolute;
  right: 10px;
  height: 1.5em;
  padding: 0 8px;
  border-radius: 10px !important;
}

.card {
  margin-bottom 1rem
  width auto
  font-size 14px
  position relative
  border-bottom 3px solid $link
  border-radius 3px
  transition all .3s
  z-index 1
  cursor pointer

  .card-content {
    height 60px
    display flex
    align-items center
    padding 0 1em
    line-height 1
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
  }

  .heading {
    display: block;
    font-size: 12px;
    letter-spacing: 1px;
    margin-bottom: 5px;
    text-transform: uppercase;
  }

  &:not(:last-child) {
    margin-bottom 1rem
  }

  &:hover {
    transform translateX(10px)
  }

  &.is-active {
    transform translateX(25px)
  }

  &.is-lock {
    opacity .5

    .index {
      background white !important
      color #363636
    }
  }

  &.is-knowledge {
    border none
    box-shadow none
    font-size 17px
    line-height 1.5
    overflow visible
  }

  .index {
    display inline-block
    background $link
    color white
    min-width 26px
    height 20px
    border-radius 15px
    font-size 12px
    text-align center
    line-height 20px
    padding 0 5px
    margin-right 10px
    transform scaleY(1)
  }

  .icon {
    color $link
  }
}
</style>
